import { useState } from "react";
import { isMobile } from "react-device-detect";
import Toast from "app/components/Toast";
import { submitFeedbackService } from "store/services/alerts/submitFB";
import { getIdsFromAlertData, seoValueParamsChangeIds } from "../../helper";

import styles from "../Empty/index.module.scss";

function SubmitFeedback({ job_search_empty, searchParams, config, dictionary }) {
  const { highlight_text, text } = job_search_empty;
  const [disable, setDisable] = useState(false);

  const handleSubmitFeedback = () => {
    const alertData = seoValueParamsChangeIds(config, searchParams);
    const data = getIdsFromAlertData(alertData);

    submitFeedbackService({ ...data, source: isMobile ? "mobile_web" : "web" })
      .then((data) => {
        Toast.success(
          dictionary?.home?.feedbackSuccessful || "Successful! Thank you for your feedback."
        );
        setDisable(true);
      })
      .catch((err) => {
        Toast.error("submit failed");
      });
  };

  return (
    <div className={styles.emptyResultDesc_content}>
      <p className={styles.emptyResultDesc_describe}>
        {dictionary?.home?.noJobsFound || "No jobs found"}
      </p>
      <div className={styles.emptyResultDesc}>{text}</div>
      <a data-disabled={disable} onClick={!disable ? handleSubmitFeedback : undefined}>
        {highlight_text}
      </a>
    </div>
  );
}

export default SubmitFeedback;
